import { render, staticRenderFns } from "./USC_AT07_AT21_x_Region.vue?vue&type=template&id=281f1882"
import script from "./USC_AT07_AT21_x_Region.vue?vue&type=script&lang=js"
export * from "./USC_AT07_AT21_x_Region.vue?vue&type=script&lang=js"
import style0 from "./USC_AT07_AT21_x_Region.vue?vue&type=style&index=0&id=281f1882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports